module.exports = __webpack_public_path__ + "img/cust_tooltips_twisto_card.880c9b4b.webp";